import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// components/gitbiz/solutions/law-firm/index.jsx (rendered by the deleted
// app/(homes)/(hrms)/hrms-software/solutions/law-firm/page.jsx) onto the content
// engine (template "solution"). Copy, images, links match the original.
// SEO comes from GeneralPageSEOMetadata.json via <SEO> (its "law-firm" entry).

export const lawFirm: ContentPage = {
  slug: "solutions/law-firm",
  template: "solution",
  seo: {
    title: "Law Firm Management Software | GetBiz Solutions",
    description: "Streamline case management, document workflows, and client communication with GetBiz Solutions’ specialized tools for law firms.",
    keywords: [
      "law firm software",
      "case management",
      "document management",
      "client communication",
      "legal software",
      "law practice management",
      "workflow automation",
      "legal technology",
    ],
    ogImage: "/assets/data/seoimages/law-firm.webp",
  },
  solution: {
    hero: {
      title: "Transform how your law firm handles casework.",
      description: "Case tracking, document management, and client interactions.",
      image: "/assets/images/img/law_firm_solutions.webp",
      imageAlt: "law_firm_solutions",
      bgImage: "/assets/images/full-width-images/section-bg-10.jpg",
      ctaPrimary: { label: "Start 15 Days Trial", href: "/pricing/" },
      ctaSecondary: { label: "Book A Demo", href: "/book-demo/" },
    },
    servicesTitle: "Streamlining Legal Operations with HRMS",
    services: [
      { title: "Employee Management", description: "Track staff hours, manage workloads, and monitor performance, all while keeping compliance in check." },
      { title: "Document Automation", description: "Automate legal documentation processes, saving time and ensuring accuracy in contracts, briefs, and filings." },
      { title: "Billing & Time Tracking", description: "Easily automate billing, time-tracking, and invoicing, ensuring timely payments and accurate records." },
      { title: "Client Communication", description: "Manage client communications through automated tracking and reporting to ensure seamless interactions." },
      { title: "Case Management", description: "Organize cases efficiently by automating document management, client communication, and case updates." },
      { title: "Legal Compliance", description: "Stay compliant with automated HR systems that track legal requirements, employee certifications, and deadlines." },
    ],
    ctaStrip: {
      description: "Book a personalized demo to see how our solutions can transform your business and boost your efficiency.",
      button: { label: "Book A Demo", href: "/book-demo/" },
    },
    faqDescription: "Explore how GetBiz Solutions helps law firms manage their cases efficiently. Our FAQs explain how you can streamline case management, track time and expenses, and automate document workflows. Discover how our tailored solutions improve your firm's productivity, allow for better collaboration, and ensure that deadlines and compliance requirements are met.",
    metaKey: "law-firm",
  },
  sections: [],
};
